import { PayloadAction, createSlice } from "@reduxjs/toolkit";
import { languageObject } from "assets/data/languages";
import { SubTopicObject } from "assets/data/topics";
import { SelectCountryObject } from "components/files/authForms/SignupForm3";
import { avatar, profileBG } from "utils/assets_exports/images";

export type DateValuePiece = Date | null;

export type DateValue = DateValuePiece | [DateValuePiece, DateValuePiece];

export type AccountState = {
    cover: string;
    avatar: string;
    name: string;
    userName: string;
    email: string;
    about: string;
    selectedTopics: SubTopicObject[];
    selectedLang: languageObject[];
    country: SelectCountryObject;
    phone: string;
    website: string;
    DOB: DateValue;
};
const date = new Date();
const initialState: AccountState = {
    cover: profileBG,
    avatar: avatar,
    name: "Hiren Tank",
    userName: "hirentank",
    email: "demo@demo.com",
    about: "Lorem ipsum, dolor sit amet consectetur adipisicing elit.Alias doloribus dolores aliquam mollitia fugit inventore, veniam quae corrupti in quia quidem pariatur iure dictafugiat explicabo porro vitae. Iste, blanditiis.",
    selectedTopics: [
        { Name: "Car Sports", ParentTopicId: 1, SubTopicId: 10 },
        { Name: "Athletics", ParentTopicId: 1, SubTopicId: 11 },
        { Name: "Rugby", ParentTopicId: 1, SubTopicId: 12 },
        { Name: "Boxing", ParentTopicId: 1, SubTopicId: 13 }
    ],
    selectedLang: [
        {
            code: "en",
            name: "English",
            nativeName: "English"
        }
    ],
    country: {
        value: "EG",
        label: "Egypt",
        flag: "https://flagcdn.com/eg.svg"
    },
    phone: "+000",
    website: "",
    DOB: date
};

export const accountSlice = createSlice({
    name: "account",
    initialState,
    reducers: {
        changeName: (state, action: PayloadAction<string>) => {
            state.name = action.payload;
        },
        changeAbout: (state, action: PayloadAction<string>) => {
            state.about = action.payload;
        },
        changeAvatar: (state, action: PayloadAction<string>) => {
            state.avatar = action.payload;
        },
        changeCover: (state, action: PayloadAction<string>) => {
            state.cover = action.payload;
        },
        changeCountry: (state, action: PayloadAction<SelectCountryObject>) => {
            state.country = action.payload;
        },
        changePhone: (state, action: PayloadAction<string>) => {
            state.phone = action.payload;
        },
        changeWebsite: (state, action: PayloadAction<string>) => {
            state.website = action.payload;
        },
        changeDOB: (state, action: PayloadAction<DateValue>) => {
            state.DOB = action.payload;
        },
        addAllLangs: (state, action: PayloadAction<languageObject[]>) => {
            state.selectedLang = action.payload;
        },
        addLang: (state, action: PayloadAction<languageObject>) => {
            if (state.selectedLang.length >= 4) {
                return;
            }
            state.selectedLang = [...state.selectedLang, action.payload];
        },
        removeLang: (state, action: PayloadAction<languageObject>) => {
            state.selectedLang = state.selectedLang.filter(
                (l) => l.code != action.payload.code
            );
        },
        addAllTopics: (state, action: PayloadAction<SubTopicObject[]>) => {
            state.selectedTopics = action.payload;
        },
        addTopic: (state, action: PayloadAction<SubTopicObject>) => {
            state.selectedTopics = [...state.selectedTopics, action.payload];
        },
        removeTopic: (state, action: PayloadAction<SubTopicObject>) => {
            state.selectedTopics = state.selectedTopics.filter(
                (t) => t.SubTopicId != action.payload.SubTopicId
            );
        }
    }
});

export const {
    changeName,
    changeAbout,
    changeAvatar,
    changeCountry,
    changeCover,
    changeDOB,
    changePhone,
    changeWebsite,
    addAllLangs,
    addLang,
    addAllTopics,
    addTopic,
    removeLang,
    removeTopic
} = accountSlice.actions;

export default accountSlice.reducer;
